// Container Wrapper
import { I18nextProvider } from 'react-i18next';
import containerInstance from './i18n';

const containerI18nWrapper = ({ children }) => (
  <I18nextProvider i18n={containerInstance}>{children}</I18nextProvider>
);

export default containerI18nWrapper;
